module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiYAAAGMAgMAAACTz4HAAAAACVBMVEUAOJfXKCj///9klgArAAABFElEQVR42u3bIQ7AIBBFQTSnw3A/NKckramoWbFpCJ3n1o3/2RKrzqv+dN+jZIaCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoLyNWXGelHSGygoKCgoKCgoKCgo+ZS+Sw0FBQUFBQUFBQUFBQUFBQUFBQUFBQUFJV6zfKCgoKCgoKCgoKCcTPHdgIKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKC8l/KArNrLeEZldzsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/flag/is.png
// module id = Fp8L
// module chunks = 0